import { computed } from 'vue'
import type { ProductSearchQuery } from '@scayle/storefront-nuxt'
import type { LocationQuery } from 'vue-router'
import { parseAppliedFilters } from '../utils/appliedFilters'
import { useRoute } from '#app/composables/router'

export function useAppliedFilters(_query?: LocationQuery) {
  const route = useRoute()

  const query = computed(() => _query || route.query)

  const appliedFilter = computed<ProductSearchQuery>(() => {
    return parseAppliedFilters(query.value)
  })

  const appliedFiltersCount = computed<number>(() => {
    let count = 0

    // Add all of the different attribute/boolean filters to the count
    count += appliedFilter.value.attributes?.length ?? 0

    // Count the minPrice/maxPrice filters as one filter
    if (
      appliedFilter.value.minPrice !== undefined ||
      appliedFilter.value.maxPrice !== undefined
    ) {
      count += 1
    }

    return count
  })

  const appliedAttributeValues = computed(() => {
    const values: Record<string, Array<number>> = {}

    appliedFilter.value?.attributes?.forEach((attribute) => {
      if (attribute.type !== 'attributes' || !attribute.key) {
        return
      }

      values[attribute.key] = attribute.values as number[]
    })
    return values
  })

  const appliedBooleanValues = computed(() => {
    const values: Record<string, boolean> = {}

    appliedFilter.value?.attributes?.forEach((attribute) => {
      if (attribute.type === 'boolean') {
        values[attribute.key] = attribute.value
      }
    })
    return values
  })

  const areFiltersApplied = computed<boolean>(() => {
    return appliedFiltersCount.value > 0
  })

  return {
    appliedFilter,
    appliedFiltersCount,
    appliedAttributeValues,
    appliedBooleanValues,
    areFiltersApplied,
  }
}
